import { z } from 'zod';
import { UUIDSchema } from './common';
import { RequiredZipAddressSchema } from './address';
import { CostCenterSchema } from './cost-center';
import { MandatorSchema } from './mandator';
import { AssignedAppraiserSchema } from './user';
import { ValuationImageSchema } from './valuation';
export const CompanyNameSchema = z.object({ company_name: z.string() });
export const PersonNameSchema = z.object({ first_name: z.string(), last_name: z.string(), salutation: z.string().optional() });
export const TeamSchema = z.object({ uuid: UUIDSchema, name: z.string() });
export const CustomerAssignedAppraiserSchema = AssignedAppraiserSchema.extend({ organization_name: z.string() });
const AppraiserCompanyProfileShape = {
    mandators: MandatorSchema.array(),
    teams: TeamSchema.array(),
    cost_centers: CostCenterSchema.array(),
    assigned_appraisers: AssignedAppraiserSchema.array(),
    picture: ValuationImageSchema.optional(),
};
export const AppraiserCompanyProfileSchema = z.object(AppraiserCompanyProfileShape);
const CustomerCompanyProfileShape = {
    mandators: MandatorSchema.array(),
    teams: TeamSchema.array(),
    cost_centers: CostCenterSchema.array(),
    assigned_appraisers: CustomerAssignedAppraiserSchema.array(),
};
export const CustomerCompanyProfileSchema = z.object(CustomerCompanyProfileShape);
const AppraiserCustomerShape = {
    uuid: UUIDSchema,
    name: z.string(),
    address: RequiredZipAddressSchema,
    created_on: z.string(),
    updated_on: z.string(),
    company_profile: AppraiserCompanyProfileSchema.optional(),
};
export const LegalEntityCustomerSchema = z.object({ ...AppraiserCustomerShape, customer_type: z.literal('legal_entity') });
export const NaturalPersonCustomerSchema = z.object({ ...AppraiserCustomerShape, customer_type: z.literal('natural_person') });
export const AppraiserCustomerSchema = z.union([
    LegalEntityCustomerSchema,
    NaturalPersonCustomerSchema,
]);
const AppraiserCustomerListShape = { customers: AppraiserCustomerSchema.array() };
export const AppraiserCustomerListSchema = z.object(AppraiserCustomerListShape);
export const ChildCustomerSchema = z.object({ uuid: UUIDSchema, name: z.string() });
const CustomerShape = {
    uuid: UUIDSchema,
    name: z.string(),
    company_profile: CustomerCompanyProfileSchema.optional(),
    child_customers: ChildCustomerSchema.array(),
};
export const CustomerSchema = z.object(CustomerShape);
const CustomerListShape = { customers: CustomerSchema.array() };
export const CustomerListSchema = z.object(CustomerListShape);
const NewLegalEntityCustomerShape = { type: z.literal('legal_entity'), name: CompanyNameSchema, address: RequiredZipAddressSchema, tax_id: z.string() };
export const NewLegalEntityCustomerSchema = z.object(NewLegalEntityCustomerShape);
const NewNaturalPersonCustomerShape = { type: z.literal('natural_person'), name: PersonNameSchema, address: RequiredZipAddressSchema };
export const NewNaturalPersonCustomerSchema = z.object(NewNaturalPersonCustomerShape);
export const NewCustomerSchema = z.union([
    NewLegalEntityCustomerSchema,
    NewNaturalPersonCustomerSchema,
]);
